import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  setupTokenProvider,
  UserLessonOverview
} from '@ramsey-plus-components/learn-ui';
import { CloseIcon } from '@ramsey-design-system/icons';
import MediaObject from '@ramsey-design-system/media-object';

// Styling
import '@ramsey-design-system/media-object/dist/media-object.css';
import Icon from 'src/react/components/icon/Icon';
import tokenProviderFactory from 'src/api/token_provider';

const UserLessonOverviewContainer = ({ lessonData, fpuLogoUrl }) => {
  const [showBanner, setShowBanner] = useState(false);

  const tokenProvider = tokenProviderFactory();
  setupTokenProvider(tokenProvider);

  useEffect(() => {
    const bannerState = window.localStorage.getItem('bookmark_banner_state');
    setShowBanner(bannerState !== null ? JSON.parse(bannerState) : true);
    window.localStorage.setItem('bookmark_banner_state', JSON.stringify(false));
  }, []);

  const weekOfSomething = (
    <div className="flex items-end">
      <p className="text-2 md:text-2 text-gray-60 opacity-75 uppercase mb-1">
        {`${lessonData.title} of 9`}
      </p>
      <div className="flex-1"></div>
      <img
        style={{ maxWidth: '140px', marginBottom: '-32px' }}
        src={fpuLogoUrl}
        alt="Financial Peace University logo"
      />
    </div>
  );

  const bookmarkBanner = showBanner && (
    <div className="Bookmark">
      <MediaObject
        alignment={'center'}
        figure={<Icon name={'blue_bookmark'} className={'BookmarkIcon'} />}
      >
        <p className={'Bookmark-text'}>
          Bookmark this page to get back to it easily.
        </p>
      </MediaObject>
      <CloseIcon
        id={'close'}
        size={'small'}
        className={'rds-Icon CloseButton'}
        onClick={() => setShowBanner(false)}
      />
    </div>
  );

  const bannerWrapper = (
    <>
      {bookmarkBanner}
      {weekOfSomething}
    </>
  );

  return (
    <UserLessonOverview
      lessonData={lessonData}
      stepperBackgroundColor={'#F5F6F8'}
      notificationBanner={bannerWrapper}
    />
  );
};

UserLessonOverviewContainer.propTypes = {
  lessonData: PropTypes.object.isRequired,
  fpuLogoUrl: PropTypes.string.isRequired
};

export default UserLessonOverviewContainer;
